import { Reducer } from 'redux';
import {
  DELETE_DESK_OPENING,
  DeskOpeningActionType,
  DeskOpeningState,
  GET_DESK_OPENING_LIST,
  POST_DESK_OPENING,
  PUT_DESK_OPENING
} from '../types/deskopening.types';

const initialState: DeskOpeningState = {
  deskOpenings: [],
  selectedDeskOpening: null,
  postSuccess: null,
  lastFetch: null,
};

export const deskOpeningReducer: Reducer<DeskOpeningState> = (
  state: DeskOpeningState = initialState, action
) => {
  const timeOfAction = new Date().getTime();

  switch ((action as DeskOpeningActionType).type) {
    case GET_DESK_OPENING_LIST:
      return {
        ...state,
        deskOpenings: action.payload.deskOpenings,
        selectedDeskOpening: null,
        postSuccess: null,
        lastFetch: timeOfAction
      };
    case POST_DESK_OPENING:
      return {
        ...state,
        postSuccess: true,
        selectedDeskOpening: action.payload.newDeskOpening,
        lastFetch: timeOfAction
      };
    case PUT_DESK_OPENING:
      return {
        ...state,
        selectedDeskOpening: action.payload.selectedDeskOpening,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_DESK_OPENING:
      return {
        ...state,
        selectedDeskOpening: null,
        lastFetch: timeOfAction
      };
    default:

      return state;
  }
};
